"use client";
import dynamic from "next/dynamic";
import React from "react";
const AdsSectionCarousel = dynamic(() => import("./ads-section/components/ads-banner-carousel"), { ssr: false });
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";

const AdsBannerLoader = ({
    adsBannerComponent,
    priorityImage,
    loc,
    mobile,
    preview,
    colorStyle
}: {
    adsBannerComponent: any;
    priorityImage: boolean;
    loc: string;
    mobile: boolean;
    preview?: boolean;
    colorStyle?: any;
}) => {
    const { hasMouseMoved } = useMouseMovement();

    return hasMouseMoved ? (
        <AdsSectionCarousel
            adsBannerComponent={adsBannerComponent}
            priorityImage={priorityImage}
            loc={loc}
            mobile={mobile}
            preview={preview}
            colorStyle={colorStyle}
        />
    ) : (
        <>
            <section className="min-h-[300px]">
                {adsBannerComponent.items.map((item: any, index: number) => (
                    <img key={index} alt={item.attributes.imageAlt || "ads banner" } />
                ))}
            </section>
        </>
    );
}

export default AdsBannerLoader;